import { render, staticRenderFns } from "./NdLoadHistory.vue?vue&type=template&id=38422b26&"
import script from "./NdLoadHistory.vue?vue&type=script&lang=js&"
export * from "./NdLoadHistory.vue?vue&type=script&lang=js&"
import style0 from "./NdLoadHistory.vue?vue&type=style&index=0&id=38422b26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports